'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('dashboard', {
      url: '/dashboard',
      template: '<dashboard></dashboard>'
    });
}



// WEBPACK FOOTER //
// ./client/app/dashboard/dashboard.routes.js